import { ReactNode } from "react";
import useSalesReportData, {
  SalesReportDataContext,
} from "./useSalesReportData";

export interface SalesReportDataProviderProps {
  children?: ReactNode;
}

const SalesReportDataProvider: React.FC<SalesReportDataProviderProps> = ({
  children,
}) => {
  const context = useSalesReportData();

  return (
    <SalesReportDataContext.Provider value={context}>
      {children}
    </SalesReportDataContext.Provider>
  );
};
export default SalesReportDataProvider;
